import { render, staticRenderFns } from "./staff_card.vue?vue&type=template&id=509436bc&scoped=true&"
import script from "./staff_card.vue?vue&type=script&lang=js&"
export * from "./staff_card.vue?vue&type=script&lang=js&"
import style0 from "./staff_card.vue?vue&type=style&index=0&id=509436bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509436bc",
  null
  
)

export default component.exports